<template>
  <div>
    <div class="flex gap-2 items-center text-primary text-xl font-medium">
      <v-icon
        color="primary">
        mdi-note-text-outline
      </v-icon>
      <span>การตรวจสลิปโอนเงิน</span>
    </div>
    <v-card
      class="py-5 px-7 mt-6 rounded-lg"
      flat>
      <div class="flex flex-col sm:flex-row sm:items-center gap-3">
        <span class="text-xl font-medium">{{ $t('order.autoVerifyTitle') }}</span>
        <span
          v-if="setting.remainingAutoVerifyTrial > 0">
          ทดลองฟรีคงเหลือ {{ setting.remainingAutoVerifyTrial }}/100 ครั้ง
        </span>
      </div>
      <div class="flex flex-col items-start mt-5 gap-3">
        <order-toggle
          v-model="setting.autoVerifyPayment"
          :text="$t('order.autoVerifyPayment')"
          :state="state.autoVerifyPayment"
          text-icon="$packageTitle"
          @input="submit('autoVerifyPayment')">
        </order-toggle>
        <packing-toggle
          v-model="setting.autoVerifyAcceptOverpaid"
          :text="$t('order.autoVerifyAcceptOverpaid')"
          :state="state.autoVerifyAcceptOverpaid"
          :disable="setting.autoVerifyPayment"
          @input="submit('autoVerifyAcceptOverpaid')">
        </packing-toggle>
        <packing-toggle
          v-model="setting.autoVerifyAcceptUnderpaid"
          :text="$t('order.autoVerifyAcceptUnderpaid')"
          :state="state.autoVerifyAcceptUnderpaid"
          :disable="setting.autoVerifyPayment"
          @input="submit('autoVerifyAcceptUnderpaid')">
        </packing-toggle>
      </div>
    </v-card>
  </div>
</template>

<script>
import { GET_SETTING_ORDER } from '@/resources/graphql/query/Setting'
import PackingToggle from '@/views/ShopSetting/Pages/Packing/components/PackingToggle.vue'
import { UPDATE_SETTING } from '@/resources/graphql'
import OrderToggle from './OrderToggle.vue'

export default {
  name: 'OrderSlip',
  components: {
    OrderToggle,
    PackingToggle
  },
  apollo: {
    setting: () => ({
      fetchPolicy: 'no-cache',
      query: GET_SETTING_ORDER,
      result () {
        if (this.setting.autoTransferBank) {
          this.createOrder = true
        }
        this.setting.paymentMethods.unshift({
          display_name: 'เลือกธนาคาร',
          value: ''
        })
      }
    })
  },

  data () {
    return {
      createOrder: false,
      setting: {},
      state: {
        createOrder: 'ready',
        autoTransfer: 'ready',
        editProductAfterPay: 'ready',
        enableReadyToShipStage: 'ready',
        enableHolding: 'ready',
        posAutoRedirect: 'ready',
        liveOrderAutoMerge: 'ready',
        changePrint: 'ready',
        pendingAllOrders: 'ready',
        invoiceNumberOption: 'ready',
        preorderLimit: 'ready',
        autoVerifyPayment: 'ready',
        autoVerifyAcceptOverpaid: 'ready',
        autoVerifyAcceptUnderpaid: 'ready',
        autoCancelMarketplaceOrder: 'ready',
        autoCancelShipnityExpressOrder: 'ready'
      }
    }
  },
  methods: {
    async submit (field) {
      this.state[field] = 'loading'
      if (field === 'preorderLimit') {
        this.setting[field] = Number(this.setting[field])
      }
      const res = await this.$apollo.mutate({
        mutation: UPDATE_SETTING,
        variables: {
          input: {
            [field]: this.setting[field]
          }
        }
      }).catch(() => {})
      if (res) {
        const { data: { updateSetting } } = res
        if (updateSetting.errors && Object.keys(updateSetting.errors).length) {
          this.state[field] = 'error'
        } else {
          this.state[field] = 'success'
        }
        if (field === 'preorderLimit') {
          setTimeout(() => {
            this.state.preorderLimit = 'ready'
            this.edit = false
          }, 1000)
        }
      }
    }
  }
}
</script>
